import api from "./api";

// Salaries, and the monthly run that turns them into entries in the expense ledger.
const url = "/api/admin/payroll";

export const listEmployees = async (activeOnly = false) => {
  const { data } = await api.get(`${url}/employees`, { params: { activeOnly } });
  return Array.isArray(data) ? data : [];
};

/** Lead team members, with a flag for the ones payroll already covers. */
export const listLinkableMembers = async () => {
  const { data } = await api.get(`${url}/linkable-members`);
  return Array.isArray(data) ? data : [];
};

export const saveEmployee = async (employee) => {
  if (employee.id) {
    const { data } = await api.put(`${url}/employees/${employee.id}`, employee);
    return data;
  }
  const { data } = await api.post(`${url}/employees`, employee);
  return data;
};

export const deleteEmployee = async (id) => {
  const { data } = await api.delete(`${url}/employees/${id}`);
  return data;
};

export const listSalaryHistory = async (employeeId) => {
  const { data } = await api.get(`${url}/employees/${employeeId}/salaries`);
  return Array.isArray(data) ? data : [];
};

/** Records the rate from a date; the rate it replaces is closed the day before. */
export const setSalary = async (employeeId, salary) => {
  const { data } = await api.post(`${url}/employees/${employeeId}/salaries`, salary);
  return data;
};

export const deleteSalary = async (salaryId) => {
  const { data } = await api.delete(`${url}/salaries/${salaryId}`);
  return data;
};

/** What the month costs and what the ledger already carries, before anything is written. */
export const getPayrollPreview = async (month) => {
  const { data } = await api.get(`${url}/preview`, { params: { month } });
  return data;
};

export const runPayroll = async (month) => {
  const { data } = await api.post(`${url}/generate`, null, { params: { month } });
  return data;
};
